import styles from './calendar-style.module.css'
import { ReactComponent as ChautauquaArrowSVG } from './chautauqua-arrow.svg';

var eventColorMap = new Map();
var nextColorID = 0;

export function Calendar({month, events, year, visibleEventTypes, locationsFilters, focusedEvent, setFocusedEvent}) {

    if(month == null)
        month = new Date().getMonth();
    if(year == null)
        year = new Date().getFullYear();

    const firstDayOfMonth = new Date(year, month, 1);
    const lastDayOfMonth = new Date(year, month + 1, 0);

    let grid = [[]];
    let dayNumber = 1;

    for(let i = 0; i < firstDayOfMonth.getDay(); i++)
        grid[0][i] = 0;

    for(let i = firstDayOfMonth.getDay(); i < 7; i++)
        grid[0][i] = dayNumber++;

    for(let i = 1; dayNumber <= lastDayOfMonth.getDate(); i++) {
        grid[i] = [];
        for(let j = 0; j < 7; j++)
            grid[i][j] = (dayNumber > lastDayOfMonth.getDate()) ? 0 : dayNumber++;
    }

    eventColorMap = new Map();
    nextColorID = 0;

    return (
        <table id={styles.calendar}>
            <thead>
                <tr>
                    <th>Sunday</th>
                    <th>Monday</th>
                    <th>Tuesday</th>
                    <th>Wednesday</th>
                    <th>Thursday</th>
                    <th>Friday</th>
                    <th>Saturday</th>
                </tr>
            </thead>
            <tbody>
                {grid.map(row => <CalendarRow key={row[0]} dayNumbers={row} events={events} month={month} year={year} visibleEventTypes={visibleEventTypes} locationsFilters={locationsFilters} focusedEvent={focusedEvent} setFocusedEvent={setFocusedEvent}/>)}
            </tbody>            
        </table>
    )

}

function isThereOverlap(locationsFilters, locations) {

    if(locationsFilters.length === 0)
        return true;

    for(const location of locations) {
        let formatted = location.toLocaleLowerCase().replaceAll(' ', '-');
        if(locationsFilters.includes(formatted))
            return true;
    }

    return false;
}

function CalendarRow({dayNumbers, events, month, year, locationsFilters, focusedEvent, visibleEventTypes, setFocusedEvent}) {

    let eventsPerDay = [0, 0, 0, 0, 0, 0, 0];

    let eventsThisWeek = [];
    let eventMap = [[null, null, null, null, null, null, null]];

    for(let i = 0; i < 7; i++) {

        if(dayNumbers[i] === 0)
            continue;

        let thisDate = Math.floor(new Date(year, month, dayNumbers[i]).getTime() / 86400000);
        for(const eventType in events) {
            if(!visibleEventTypes[eventType])
                continue;

            for(const id in events[eventType]) {
                let startDate = Math.floor((events[eventType][id].start_date.seconds - 14400)/ 86400);
                let endDate =   Math.floor((events[eventType][id].end_date.seconds - 14400)  / 86400);

                if(startDate <= thisDate && endDate >= thisDate) {
                    if(!isThereOverlap(locationsFilters, events[eventType][id].locations))
                        continue;

                    if(!eventsThisWeek.includes(events[eventType][id])) {
                        eventsThisWeek.push(events[eventType][id]);

                        if(eventMap.length <= Math.max(...eventsPerDay)) {
                            eventMap.push([null, null, null, null, null, null, null])
                        }

                        for(let j = i; j - i < (endDate - Math.max(startDate, thisDate) + 1) && j < 7; j++) {
                            eventMap[eventsPerDay[i]][j] = eventsThisWeek.indexOf(events[eventType][id]);

                            if(i !== j)
                                eventsPerDay[j] = eventsPerDay[i] + 1;
                        }
    
                        eventsPerDay[i]++;
                    }
                }
            }
        }
    }

    let lastRowIsUsed = false;

    for(let i = 0; i < 7; i++)
        lastRowIsUsed = lastRowIsUsed || eventMap[eventMap.length - 1][i] != null;

    if(!lastRowIsUsed)
      eventMap.splice(eventMap.length - 1, 1);

    return (
        <tr>
            <td><CalendarDay  events={eventsThisWeek} eventMap={eventMap} dayOfWeek={0} month={month} year={year} dayOfMonth={dayNumbers[0]} setFocusedEvent={setFocusedEvent} focusedEvent={focusedEvent}/></td>
            <td><CalendarDay  events={eventsThisWeek} eventMap={eventMap} dayOfWeek={1} month={month} year={year} dayOfMonth={dayNumbers[1]} setFocusedEvent={setFocusedEvent} focusedEvent={focusedEvent}/></td>
            <td><CalendarDay  events={eventsThisWeek} eventMap={eventMap} dayOfWeek={2} month={month} year={year} dayOfMonth={dayNumbers[2]} setFocusedEvent={setFocusedEvent} focusedEvent={focusedEvent}/></td>
            <td><CalendarDay  events={eventsThisWeek} eventMap={eventMap} dayOfWeek={3} month={month} year={year} dayOfMonth={dayNumbers[3]} setFocusedEvent={setFocusedEvent} focusedEvent={focusedEvent}/></td>
            <td><CalendarDay  events={eventsThisWeek} eventMap={eventMap} dayOfWeek={4} month={month} year={year} dayOfMonth={dayNumbers[4]} setFocusedEvent={setFocusedEvent} focusedEvent={focusedEvent}/></td>
            <td><CalendarDay  events={eventsThisWeek} eventMap={eventMap} dayOfWeek={5} month={month} year={year} dayOfMonth={dayNumbers[5]} setFocusedEvent={setFocusedEvent} focusedEvent={focusedEvent}/></td>
            <td><CalendarDay  events={eventsThisWeek} eventMap={eventMap} dayOfWeek={6} month={month} year={year} dayOfMonth={dayNumbers[6]} setFocusedEvent={setFocusedEvent} focusedEvent={focusedEvent}/></td>
        </tr>
    )    
}

const TODAY_EPOCH_DAY = Math.floor(new Date().getTime() / 86400000);

function CalendarDay({events, eventMap, dayOfWeek, month, year, dayOfMonth,  focusedEvent, setFocusedEvent}) {
    let label = (dayOfMonth !== 0) ? dayOfMonth.toString() : "";

    if(dayOfMonth !== 0) {
        let thisDate = Math.floor(new Date(year, month, dayOfMonth).getTime() / 86400000);
        let className = styles.day;
        let eventsOnThisDay = [];

        if(TODAY_EPOCH_DAY === thisDate)
            className += ' '+styles.today;

        for(let i = 0; i < eventMap.length; i++) {
            if(eventMap[i][dayOfWeek] != null) {

                let event = events[eventMap[i][dayOfWeek]];
                let startDate = Math.floor((event.start_date.seconds - 14400) / 86400)
                let endDate = Math.floor((event.end_date.seconds - 14400) / 86400)
                let eventLength = endDate - startDate + 1;

                if(startDate === thisDate) {
                    let length = Math.min(eventLength, 7 - dayOfWeek);

                    eventsOnThisDay.push({
                        event: events[eventMap[i][dayOfWeek]],
                        length: length,
                        overflowRight: endDate - thisDate + 1 !== length
                    });

                } else if (dayOfWeek === 0 || dayOfMonth === 1) {
                    let eventLength = endDate - thisDate + 1;
                    let length = Math.min(eventLength, 7 - dayOfWeek);

                    eventsOnThisDay.push({
                        event: events[eventMap[i][dayOfWeek]],
                        length: length,
                        overflowLeft: true,
                        overflowRight: eventLength !== length
                    });

                } else
                    eventsOnThisDay.push({
                        event: null
                    });
            } else
                eventsOnThisDay.push({
                    event: null
                });
        }

        return (
            <div className={className}>
                <div className={styles.number}>{label}</div>
                <div className="events">
                    {eventsOnThisDay.map(eventData => 
                    <EventBar key={Math.random()} eventData={eventData} focusedEvent={focusedEvent} setFocusedEvent={setFocusedEvent}/>)}
                </div>
                
            </div>
        );
    }

    return (
        <div className={`${styles.day} ${styles.greyed}`}></div>
    );
}

function getColorFromColorID(colorID) {
    if(colorID % 6 === 0)
        return "var(--chautauqua-blue-500)";
    else if(colorID % 6 === 1)
        return "var(--chautauqua-blue-400)";
    else if(colorID % 6 === 2)
        return "var(--chautauqua-blue-300)";
    else if(colorID % 6 === 3)
        return "var(--chautauqua-green-300)";
    else if(colorID % 6 === 4)
        return "var(--chautauqua-green-400)";
    else
        return "var(--chautauqua-green-500)";
}

function EventBar({eventData, focusedEvent, setFocusedEvent}) {

    let width = `calc(${eventData.length * 100}% - 2pt + 3pt * ${eventData.length - 1}${eventData.overflowLeft ? "" : " - 10pt"}${eventData.overflowRight ? "" : " - 10pt"})`;

    if(eventData.event != null) {
        let colorID = eventColorMap.get(eventData.event);
        let isFocused = focusedEvent?.id === eventData.event?.id;

        if(colorID == null) {
            colorID = nextColorID++;
            eventColorMap.set(eventData.event, colorID);
        }

        let color = getColorFromColorID(colorID);

        const onClicked = () => {
            setFocusedEvent(eventData.event);
        }

        return (
            <div className={styles.event_bar} onClick={onClicked}
                    style={{
                        background: color,
                        width: width,
                        marginLeft: (eventData.overflowLeft) ? "1pt" : "10pt",
                        marginRight: (eventData.overflowRight) ? "1pt" : "10pt",
                        borderWidth: isFocused ? '1px' : '0',
                        padding: !isFocused ? '1px' : '0'
                    }}
                >
                <ChautauquaArrowSVG fill="#FFFFFF" className={`${styles.arrow} ${styles.left}`} style={{visibility: (eventData.overflowLeft) ? "visible" : "hidden"}}/>
                <div className={styles.name}>{`${eventData.event.name}`}</div>                
                <ChautauquaArrowSVG fill="#FFFFFF" className={`${styles.arrow} ${styles.right}`} style={{visibility: (eventData.overflowRight) ? "visible" : "hidden"}}/>
            </div>
        )
    } else 
        return (
            <div className={styles.spacer} style={{width: "100%"}}>s</div>
        )
}